import { atom, useAtom } from "jotai";

export enum AuthModalScreen {
  EnterEmail = 0,
  EnterPassword = 1,
  Register = 2,
  OnboardingStep1 = 3,
  OnboardingStep2 = 4,
  OnboardingStep3 = 5,
  OnboardingStep4 = 6,
  OnboardingStep5 = 7,
  VerifyEmail = 8,
  ForgotPassword = 9,
  ResetForgotPassword = 10,
  OnboardingScreen = 11,
  VerifyTermsAndConditions = 12,
}

export const authModalOpenAtom = atom(false);
export const viewIndexAtom = atom<AuthModalScreen>(AuthModalScreen.EnterEmail);

export function useAuthModals() {
  const [authModal, setAuthModal] = useAtom(authModalOpenAtom);
  const [screenIndex, setScreenIndex] = useAtom(viewIndexAtom);

  const showModal = (screenIndex: AuthModalScreen) => {
    // console.log("show");
    setAuthModal(true);
    setScreenIndex(screenIndex);
  };

  const hideModal = () => {
    // console.log("hide");
    setAuthModal(false);
  };

  return {
    showModal,
    hideModal,
    isAuthModalVisible: authModal,
    screenIndex,
    setScreenIndex,
  };
}
